import { registryApi } from '../clients/AxiosClients'

/**
 * Retorna todas as categorias de arvores cadastradas no banco de dados
 */
const listarCategoriasDeFitossanidade = async () => {
	return registryApi.get('v1/categoriadefitossanidade/listar-categorias-de-fitossanidade')
}

/**
 * Cadastrar nova categoria de arvore no banco de dados
 * @param {Object} body Categoria de arvore que será cadastrada
 */
const cadastrarCategoriaDeFitossanidade = async (body) => {
	return registryApi.post('v1/categoriadefitossanidade/cadastrar-categoria-de-fitossanidade', body)
}

/**
 * Atualiza categoria de arvore no banco de dados
 * @param {Object} body Categoria de Arvore que será atualizada
 */
const atualizarCategoriaDeFitossanidade = async (body) => {
	return registryApi.put(
		`v1/categoriadefitossanidade/atualizar-categoria-de-fitossanidade?idCategoria=${body.id}`,
		body,
	)
}

/**
 * Lista dos ids de categorias de arvore que devem ser excluidos do banco de dados
 * @param {Array} body Lista dos ids de categoria de arvores
 */
const excluirListaDeCategoriasDeFitossanidade = async (data) => {
	return registryApi.delete(
		'v1/categoriadefitossanidade/excluir-lista-de-categoria-de-fitossanidade',
		{ data },
	)
}

export {
	listarCategoriasDeFitossanidade,
	cadastrarCategoriaDeFitossanidade,
	atualizarCategoriaDeFitossanidade,
	excluirListaDeCategoriasDeFitossanidade,
}
